import { Link } from "react-router-dom";
import { SocialIcon } from "../components/SocialIcon";
import { NAV_LINKS, SOCIAL_LINKS } from "../data/links";
import { MARRIAGE_REWARD_ENABLED, REWARD_TERMS_PATH } from "../data/reward";
import { useLanguageSwitch } from "../hooks/useLanguageSwitch";
import { SectionLink } from "../components/SectionLink";
import { useSiteTranslation } from "../i18n";
import logo from "../../../pictures/home/logo-m.png";
import "../styles/footer.css";

const EXPLORE_LINKS = NAV_LINKS.filter((link) => link.href !== "#safety");

const PAGE_GROUPS = [
  {
    title: "footer.support",
    links: [
      { to: "/safety", label: "footer.safety" },
      { to: "/help", label: "footer.help" },
      { to: "/contactus", label: "footer.contact" },
    ],
  },
  {
    title: "footer.legal",
    links: [
      { to: "/privacy", label: "footer.privacy" },
      { to: "/termsandconditions", label: "footer.terms" },
      { to: "/communityguidelines", label: "footer.guidelines" },
      ...(MARRIAGE_REWARD_ENABLED ? [{ to: REWARD_TERMS_PATH, label: "footer.reward" }] : []),
    ],
  },
];

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ar", label: "العربية" },
];

export function HomeFooter() {
  const { language, setLanguage } = useLanguageSwitch();
  const { t } = useSiteTranslation();

  return (
    <footer className="footer">
      <div className="wrap footer-grid">
        <div className="footer-brand">
          <img src={logo} alt="MJMarry" />
          <p>{t("footer.tagline")}</p>
          <div className="footer-social">
            {SOCIAL_LINKS.map(({ name, label, href }) => (
              <a key={name} href={href} target="_blank" rel="noopener noreferrer" aria-label={t(label)} title={t(label)}>
                <SocialIcon name={name} />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h3>{t("footer.explore")}</h3>
          {EXPLORE_LINKS.map(({ href, label }) => (
            <SectionLink key={href} hash={href}>
              {t(label)}
            </SectionLink>
          ))}
        </div>
        {PAGE_GROUPS.map((group) => (
          <div key={group.title}>
            <h3>{t(group.title)}</h3>
            {group.links.map(({ to, label }) => (
              <Link key={to} to={to}>
                {t(label)}
              </Link>
            ))}
          </div>
        ))}
      </div>
      <div className="wrap footer-bottom">
        <span>{t("common.rights", { year: new Date().getFullYear() })}</span>
        <span>
          {LANGUAGES.map(({ code, label }, index) => (
            <span key={code} className="footer-lang-item">
              {index > 0 && <i />}
              <button
                type="button"
                lang={code}
                className={`footer-lang${language === code ? " current" : ""}`}
                onClick={() => setLanguage(code)}
              >
                {label}
              </button>
            </span>
          ))}
        </span>
      </div>
    </footer>
  );
}
